import React from 'react'
import './Settings.css'
import { Avatar } from '@material-ui/core'
import NotificationsIcon from '@material-ui/icons/Notifications';
import LockIcon from '@material-ui/icons/Lock';
import SecurityIcon from '@material-ui/icons/Security';
import BrightnessMediumIcon from '@material-ui/icons/BrightnessMedium';
import WallpaperIcon from '@material-ui/icons/Wallpaper';
import DescriptionIcon from '@material-ui/icons/Description';
import BrightnessAutoIcon from '@material-ui/icons/BrightnessAuto';
import HelpIcon from '@material-ui/icons/Help';

const Settings = () => {
  return (
    <div className="settings">
      <div className="bio">
        <Avatar className="avatar" src="https://pps.whatsapp.net/v/t61.24694-24/263117074_716090416423132_1771546977815979544_n.jpg?ccb=11-4&oh=b307b8ca182b28a5219a5aa6397cb0b1&oe=62B84F45" />
        <div className="info">
          <h2>Black~vibes 👑</h2>
          <h3>React js developer || Frontend Developer</h3>
        </div>
      </div>
      <div className="links">
        <ul>
          <li>
            <NotificationsIcon />
            <h4>Notifications</h4>
          </li>
          <li>
            <LockIcon />
            <h4>Privacy</h4>
          </li>
          <li>
            <SecurityIcon />
            <h4>Security</h4>
          </li>
          <li>
            <BrightnessMediumIcon />
            <h4>Theme</h4>
          </li>
          <li>
            <WallpaperIcon />
            <h4>Chat Wallpaper</h4>
          </li>
          <li>
            <DescriptionIcon />
            <h4>Request Account Info</h4>
          </li>
          <li>
            <BrightnessAutoIcon />
            <h4>Keyboard Shortcuts</h4>
          </li>
          <li>
            <HelpIcon />
            <h4>Help</h4>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Settings